// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_o0-0";
export var animationContainer = "_o0-1";
export var itemPrice = "_o0-a";
export var itemizedContent = "_o0-9";
export var itemizedHeader = "_o0-7";
export var itemizedRow = "_o0-8";
export var itemizedSection = "_o0-6";
export var modalContent = "_o0-2";
export var orderName = "_o0-3";
export var refundOption = "_o0-4";
export var refundOptionsContainer = "_o0-5";
export var shippingLabel = "_o0-b";
export var totalRow = "_o0-c";